import { z } from 'zod';

import { defaultPagingSchema } from '../../../../helpers/schemas/defaultPagingSchema';
import { getIdentityVerificationFilterFormSchema } from '../components/IdentityVerificationFilter/helpers/getIdentityVerificationFilterFormSchema';

import { identityVerificationSortSchema } from './identityVerificationSortSchema';

export const identityVerificationFilterSchema =
	getIdentityVerificationFilterFormSchema().optional().catch(undefined);

export const identityVerificationValidateSearchSchema =
	defaultPagingSchema.extend({
		openedVerification: z.string().optional().catch(undefined),
		filter: identityVerificationFilterSchema,
		sort: identityVerificationSortSchema,
	});
